import React from "react";
import { useHistory } from "react-router-dom";

import { useStateSelector } from "utils/field";

import InsightsTag from "features/Insights/InsightsTag";
import ReviewProgressIndicator from "./ReviewProgressIndicator";

import classes from "./styles.module.scss";

const ModelTopBar = ({
    title,
    subtitle,
    modelId,
    isInsightsActive,
    simulationCompletion,
    simulationChecks,
    modelComplete = false,
    hasSimulationResults = false,
    children,
}) => {
    const history = useHistory();

    const isUserVerified = useStateSelector("user.isUserVerified") || false;

    return (
        <div className={classes.modelTopBar}>
            <div className={classes.left}>
                <div className={classes.titleRow}>
                    <p className={classes.title} data-tip={title} data-for="modelNameTip">
                        {title}
                    </p>
                    <InsightsTag
                        isInsightsActive={isInsightsActive}
                        onClick={modelId ? () => history.push(`/insights/${modelId}`) : undefined}
                        disabled={!isUserVerified}
                    />
                    <ReviewProgressIndicator
                        percentage={simulationCompletion}
                        checks={simulationChecks}
                        modelComplete={modelComplete}
                        hasSimulationResults={hasSimulationResults}
                    />
                </div>
                <span className={classes.subtitle}>{subtitle}</span>
            </div>
            <div className={classes.right}>{children}</div>
        </div>
    );
};

export default ModelTopBar;
